import { render } from "./WhatsAppPreview.vue?vue&type=template&id=c61934be&scoped=true"
import script from "./WhatsAppPreview.vue?vue&type=script&lang=js"
export * from "./WhatsAppPreview.vue?vue&type=script&lang=js"

import "./WhatsAppPreview.vue?vue&type=style&index=0&id=c61934be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c61934be"]])

export default __exports__